/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/**
 * A module that helps determine if an error instance is the same as another or
 * inherits from it.
 * @module utilities/errors/compareErrors
 */
"use strict";

var deprecate = require("depd")("@auex/utilities");

// FIXME: Figure out a way to use our sibling environment variable utilities,
// perhaps if we migrate to AVA one day.
var isDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
var isTest = process.env.TEST_ENV === "intern";
var isDevOrTest = isDev || isTest;

var FunctionCallError = require("./functions");
var InvalidParameterError = FunctionCallError.InvalidParameterError;

/**
 * Compares two error instances and tries to determine if they're the same or
 * part of the same inheritance tree.
 *
 * @param {Error} error - An Error (or descendant) instance.
 * @param {Function} errorConstructor - Constructor of an error or descendant to
 *                                      test against.
 * @return {boolean} Whether the error is an instance of the errorConstructor.
 */
function compareErrors(error, errorConstructor) {
  if (!(error instanceof Error)) {
    throw new InvalidParameterError(null, "The first parameter must be an error instance.");
  }

  if (error instanceof errorConstructor) {
    return true;
  }

  if (isDevOrTest) {
    return error.constructor.name === errorConstructor.name;
  }

  return false;
}

module.exports = deprecate.function(compareErrors, "'compareErrors' is deprecated in this module. Please use" + " '@novivia/utilities/errors/errorIsInstanceOf' instead.");


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/utilities/lib/errors/compareErrors.js
// module id = 868
// module chunks = 6